import { render, staticRenderFns } from "./Edit-User-Func.vue?vue&type=template&id=2225a18e&scoped=true&"
import script from "./Edit-User-Func.vue?vue&type=script&lang=js&"
export * from "./Edit-User-Func.vue?vue&type=script&lang=js&"
import style0 from "./Edit-User-Func.vue?vue&type=style&index=0&id=2225a18e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2225a18e",
  null
  
)

export default component.exports